import {
  h2h,
  h2hNew,
  h2hIntegration,
  mStats,
  comparison,
  standings,
  tracker,
  preview,
  momentum,
  generalStatistics,
  lineups,
  liveTable,
  basketballHeatmap,
  table,
  distributionOfGoals
} from './widget.config.js'

// 获取 preMatch 及普通 widget navs
export const getPrematchWidgetNavs = (sportId = '') => {
  switch (sportId) {
    case 'sr:sport:1': // soccer
      return [h2hIntegration, mStats, comparison, standings]
    case 'sr:sport:137': // esport soccer
      return [h2h, h2hNew, comparison, standings]
    case 'sr:sport:2': // basketball
    case 'sr:sport:153': // esport basketball
      return [h2h, h2hNew]
    case 'sr:sport:3': // baseball
    case 'sr:sport:4': // Ice Hockey
    case 'sr:sport:5': // tennis
    case 'sr:sport:6': // Handball
      return [h2hNew, preview]
    case 'sr:sport:13': // Aussie Rules
      return [h2hNew]
    case 'sr:sport:109': // Counter-Strike
    case 'sr:sport:110': // League of Legends
    case 'sr:sport:111': // Dota2
      return [
        {
          label: 'Statistics',
          name: 'iframe-statistics'
        }
      ]
    case 'lv:sport:1': // esport soccer
      return [h2h, table, standings]
    // case 'sr:sport:20': // table tennis
    // case 'sr:sport:21': // cricket
    // case 'sr:sport:12': // rugby
    // case 'sr:sport:23': // Volleyball
    // case 'sr:sport:31': // Badminton
    // case 'sr:sport:195': // esport ice hockey
    // case 'sr:sport:22': // Darts
    // case 'sr:sport:29': // Futsal
    // case 'sr:sport:19': // Snooker'
    //   return [h2hNew, tracker]
    default:
      return [h2hNew, tracker]
  }
}

// 获取 bet assist(live) widget navs
export const getBetAssistWidgetNavs = (sportId = '') => {
  switch (sportId) {
    case 'sr:sport:1': // soccer
      return [
        {
          label: 'Statistics',
          name: 'statistics',
          children: [distributionOfGoals, momentum, generalStatistics]
        },
        lineups,
        liveTable
      ]
    case 'sr:sport:137': // esport soccer
      return [
        {
          label: 'Statistics',
          name: 'statistics',
          children: [momentum, generalStatistics]
        },
        lineups,
        liveTable
      ]
    case 'sr:sport:2': // basketball
    case 'sr:sport:153': // esport basketball
      return [
        {
          label: 'Statistics',
          name: 'statistics',
          children: [momentum, generalStatistics]
        },
        liveTable,
        basketballHeatmap
      ]
    case 'sr:sport:23': // volleyball
      return [generalStatistics, liveTable]
    default:
      return null
  }
}
